import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  OutlineElement,
  SlotsController,
  LightDomStyles,
} from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './outline-emergency-takeover.css.lit';
import '../outline-icon-baseline/outline-icon-baseline';
import '../outline-container-baseline/outline-container-baseline';

/**
 * The OutlineEmergencyTakeover component
 * @element outline-emergency-takeover
 */
@customElement('outline-emergency-takeover')
export class OutlineEmergencyTakeover extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  /**
   * Determines weather the takeover is open or not
   */
  @property({ type: Boolean, reflect: true, attribute: 'is-open' })
  isOpen = true;

  /**
   * Alert background color
   */
  @property({ type: String, reflect: true, attribute: 'background-color' })
  backgroundColor = 'brand-dark-blue-900';

  /**
   * Alert text color
   */
  @property({ type: String, reflect: true, attribute: 'text-color' })
  textColor = 'brand-white';

  /**
   * Alert icon
   */
  @property({ type: String, reflect: true, attribute: 'icon' })
  icon = 'eu-alert';

  close() {
    this.isOpen = false;
  }

  slots = new SlotsController(this);

  updated() {
    this.style.setProperty('--alert-text-color', `var(--${this.textColor})`);
  }

  render(): TemplateResult | null {
    if (!this.isOpen) return null;

    return html`
      <div class="emergency-takeover-wrapper">
        <div
          class="emergency-takeover-container"
          style="background-color: var(--${this.backgroundColor});"
        >
          ${this.querySelector('[slot="close-button"]') !== null
            ? html` <slot name="close-button"></slot> `
            : html`
                <button
                  @click="${this.close}"
                  class="emergency-takeover-close"
                  aria-label="Hide alert"
                >
                  <outline-icon-baseline
                    name="eu-x"
                    size="1rem"
                  ></outline-icon-baseline>
                </button>
              `}
          <outline-container-baseline content-max-width="small">
            <div class="emergency-takeover-content">
              <outline-icon-baseline
                name="${this.icon}"
                size="2.25rem"
                class="emergency-takeover-icon"
              >
              </outline-icon-baseline>
              ${this.slots.conditionalSlot('title', false)}
              ${this.slots.conditionalSlot('body', false)}
              ${this.slots.conditionalSlot('cta', false)}
            </div>
          </outline-container-baseline>
        </div>
      </div>
    `;
  }
}
